export const GHOST_TYPES = [
  {
    id: 1,
    name: 'Banshee',
    evidence: [1,2,3],
    weakness: 'Crucifix'
  },
  {
    id: 2,
    name: 'Demon',
    evidence: [3,5,6],
    weakness: 'Successful questions on Ouija board'
  },
  {
    id: 3,
    name: 'Jinn',
    evidence: [1,4,6],
    weakness: 'Turn off the power'
  },
  {
    id: 4,
    name: 'Mare',
    evidence: [3,4,6],
    weakness: 'Turn on the lights'
  },
  {
    id: 5,
    name: 'Oni',
    evidence: [1,5,6],
    weakness: 'Player activity'
  },
  {
    id: 6,
    name: 'Phantom',
    evidence: [1,3,4],
    weakness: 'Take photos'
  },
  {
    id: 7,
    name: 'Poltergeist',
    evidence: [2,4,6],
    weakness: 'Empty Room'
  },
  {
    id: 8,
    name: 'Revenant',
    evidence: [1,2,5],
    weakness: 'Avoid line of sight'
  },
  {
    id: 9,
    name: 'Shade',
    evidence: [1,4,5],
    weakness: 'Multiple people in the room'
  },
  {
    id: 10,
    name: 'Spirit',
    evidence: [2,5,6],
    weakness: 'Smudge Sticks'
  },
  {
    id: 11,
    name: 'Wraith',
    evidence: [2,3,6],
    weakness: 'Salt'
  },
  {
    id: 12,
    name: 'Yurei',
    evidence: [3,4,5],
    weakness: 'Smudge Sticks in spawn rooms'
  },
  {
    id: 13,
    name: 'Hantu',
    evidence: [2,4,5],
    weakness: 'Slower in warmer rooms'
  },
  {
    id: 14,
    name: 'Yokai',
    evidence: [4,5,6],
    weakness: 'While hunting, yokai can only hear voices nearby'
  }
]

export const EVIDENCE = [
  {
    id: 1,
    name: 'EMF Level 5'
  },
  {
    id: 2,
    name: 'Fingerprints'
  },
  {
    id: 3,
    name: 'Freezing Temps'
  },
  {
    id: 4,
    name: 'Ghost Orb'
  },
  {
    id: 5,
    name: 'Ghost Writing'
  },
  {
    id: 6,
    name: 'Spirit Box'
  }
]
